import React, { createContext, useContext, useState } from "react";

const MandateCtx = createContext(null);

const initialState = {
  householdNumber: "",
  householdId: null,
  householdName: "",
  branchName: "",
  searchedMembers: [],
  selectedMember: null,       // { memberId, memberName, mobileNo, family_member_id, relationName, vpaDetails }
  provider: "PHONEPE",        // always PHONEPE (only backend supported)
  status: "idle",             // idle | authorising | success | failed
  redirectType: "",           // QR string / base64 image returned by PhonePe
  redirectUrl: "",            // ppe://... deep-link for UPI app buttons
  authRequestId: "",          // stored after registration — used as fallback for polling
  merchantUserId: "",         // third_reference_number_nach — primary polling key
  maxBillingAmount: "",      // fetched from backend (max amount in rupees)
  mandateRef: "",             // subscription_id returned by registration
};

export function MandateProvider({ children }) {
  const [state, setState] = useState(initialState);

  const update = (patch) => setState((prev) => ({ ...prev, ...patch }));
  const reset  = () => setState(initialState);

  return (
    <MandateCtx.Provider value={{ state, update, reset }}>
      {children}
    </MandateCtx.Provider>
  );
}

export function useMandate() {
  return useContext(MandateCtx);
}
